import { createFileRoute } from '@tanstack/react-router'

import { blogPageQueries } from 'lib/queries'

import BlogIndex from 'pages/Blog/BlogIndex'

export const Route = createFileRoute('/blog/')({
  loader: ({ context }) =>
    context.queryClient.ensureQueryData(blogPageQueries.index()),
  component: BlogIndex,
})
